import CalqResultsAsync from './CalqResultsAsync';

export default CalqResultsAsync;
